module.exports = __webpack_public_path__ + "static/media/redeemIcon.ab8aec12.svg";